module.exports = __webpack_public_path__ + "img/selected5-min.aeb6975a.png";